import React, { Fragment, useMemo } from 'react';
import BEMHelper from 'react-bem-helper';
import PropTypes from 'prop-types';
import { ImageView } from '../ImageView';
import { isMobile } from '@ringcentral/rwc-utils/src/client-detection';
import DOMPurify from 'dompurify';
import OneTrustEntry from './OneTrustEntry';

import './style.common.less';

export const classes = new BEMHelper('CommonFooter');

const Footer = ({ links, copyright, logoLink, poweredByLogoUrl }) => {
    const _copyright = useMemo(
        () => ({
            __html: DOMPurify.sanitize(copyright, {
                USE_PROFILES: { html: true },
            }),
        }),
        [copyright]
    );
    const showFooter = !isMobile || (logoLink && poweredByLogoUrl);

    return (
        <Fragment>
            {showFooter && (
                <footer {...classes()}>
                    {!isMobile && (
                        <div {...classes('left')}>
                            <div {...classes('links')}>
                                <a href={links.legal.href} target='_blank' rel='noreferrer'>
                                    {links.legal.text}
                                </a>
                                {' | '}
                                <a href={links.privacy.href} target='_blank' rel='noreferrer'>
                                    {links.privacy.text}
                                </a>
                                <OneTrustEntry text={links.cookie_preferences.text}>
                                    {entry => (
                                        <Fragment>
                                            {' | '}
                                            {entry}
                                        </Fragment>
                                    )}
                                </OneTrustEntry>
                            </div>
                            <div {...classes('copyright')} dangerouslySetInnerHTML={_copyright} />
                        </div>
                    )}
                    <div {...classes('right')}>
                        {logoLink && poweredByLogoUrl && (
                            <a href={logoLink} target='_blank' rel='noreferrer'>
                                <ImageView src={poweredByLogoUrl} className='logo' />
                            </a>
                        )}
                    </div>
                </footer>
            )}
            {isMobile && <OneTrustEntry text={links.cookie_preferences.text} />}
        </Fragment>
    );
};

Footer.propTypes = {
    links: PropTypes.object,
    copyright: PropTypes.string,
    logoLink: PropTypes.string,
    poweredByLogoUrl: PropTypes.string,
};

export default Footer;
